import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useMediaBreakpoint } from '@americanexpress/consumer-travel-base';
import DateInput from '../DateInput/DateInput';
import TimeDropdown from '../TimeDropdown/TimeDropdown';

const DateTimeField = ({
  shownDate,
  placeholder,
  hasTimeDropdown,
  onChangeInput,
  stateKey,
  timeAriaLabel,
  className,
  onChangeTime,
}) => {
  const isMobile = useMediaBreakpoint('sm-down');
  return (
    <div className={className}>
      <DateInput
        onChangeAction={onChangeInput}
        stateKey={`${stateKey}Date`}
        initialDate={shownDate}
        placeholder={placeholder}
        className={clsx({
          'width-full': isMobile,
        })}
      />
      {
        hasTimeDropdown && (
          <TimeDropdown
            ariaLabel={timeAriaLabel}
            stateKey={`${stateKey}Time`}
            onChangeAction={onChangeTime}
            className={clsx(!isMobile ? 'pad-1-l' : 'width-full')}
          />
        )
      }
    </div>
  );
};

DateTimeField.propTypes = {
  shownDate: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  hasTimeDropdown: PropTypes.bool.isRequired,
  onChangeInput: PropTypes.func.isRequired,
  onChangeTime: PropTypes.func,
  stateKey: PropTypes.string.isRequired,
  timeAriaLabel: PropTypes.string,
  className: PropTypes.string,
};

export default DateTimeField;
